<template>
  <div>
    <validation-observer>
      <div
        v-for="(answerType, atIndex) in input"
        :key="`at-${atIndex}`"
        class="mt-4 row align-items-center justify-content-start"
      >
        <input class="custom-radio ms" disabled type="radio" />
        <div class="col-8 col-lg-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="answerType.name"
              custom-error-msg="El campo es requerido."
              :error="errors[0]"
            />
          </validation-provider>
        </div>
        <div v-if="atIndex > 1" class="col-2 col-lg-3">
          <i
            class="far fa-times-circle text-danger"
            @click="triggerConfirmation(atIndex)"
          />
        </div>
      </div>

      <div class="mt-4 row align-items-center justify-content-start">
        <input v-if="canAddMore" class="custom-radio" disabled type="radio" />
        <div v-if="canAddMore" class="col-8 col-lg-2">
          <u class="add-button" @click="addAnswer">
            Agregar una opción
          </u>
        </div>
        <input class="custom-radio" disabled type="radio" />
        <div class="col-8 col-lg-2">
          <u class="add-button" @click="addChild">
            Agregar Dependencia
          </u>
        </div>
      </div>
      <div
        v-for="(child, cqIndex) in childQuestions"
        :key="`cq-${cqIndex}`"
        class="ml-3 mt-4 row border-start border-1 align-items-center justify-content-start custom-border w-75 p-3"
      >
        <div class="col-12 pb-2 border-bottom row">
          <div class="col-10">
            <i class="fas fa-pen text-orange mr-2" />
            <span class="custom-sub-title">{{ title(child, cqIndex) }}</span>
          </div>
          <div class="col-2 d-flex justify-content-end">
            <i
              class="far fa-times-circle text-danger"
              @click="triggerSubAnwserConfirmation(cqIndex)"
            />
          </div>
        </div>
        <div class="my-2 col-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <div class="text">
              Pregunta o Descripción:
            </div>
            <custom-input
              v-model="child.name"
              :custom-error-msg="'El campor es requerido.'"
              :error="errors[0]"
              maxlength="500"
              placeholder="Escribe tu Pregunta o Descripción"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-6 my-2">
          <validation-provider v-slot="{ errors }" rules="required">
            <div class="text">
              Opción de Respuesta:
            </div>
            <select
              v-model="child.typeId"
              class="form-control"
              :class="{ error: errors.length > 0 }"
              custom-error-msg="El campo es requerido."
              :error="errors[0]"
              placeholder="Seleccione"
            >
              <option disabled hidden selected value="">
                Seleccione
              </option>
              <option
                v-for="(type, aatIndex) in availableAnswersTypes"
                :key="`aat-${aatIndex}`"
                class="fa"
                :value="type.id"
                v-html="`${type.icon} ${type.name}`"
              />
            </select>
            <custom-error
              v-if="errors.length > 0"
              :message="'El campo es requerido'"
              variant="no-border mt-1"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-6 my-2" @click="getUnselected(child)">
          <validation-provider v-slot="{ errors }" rules="required">
            <div class="text">
              Enlazar a:
            </div>
            <custom-drop-down
              v-model="child.linkedAnswer"
              :clearable="false"
              custom-error-msg="Favor Seleccionar"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="availableOptions"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <!-- AnwserTypes -->
        <div class="col-12 my-2">
          <vertical-inputs
            v-if="child.typeId == selection.simpleVertical"
            :input.sync="child.answers"
          />

          <multiple-selection
            v-if="child.typeId == selection.multipleHorizontal"
            :input.sync="child.answers"
            :orientation="'horizontal'"
          />

          <multiple-selection
            v-if="child.typeId == selection.multipleVertical"
            :input.sync="child.answers"
            :orientation="'vertical'"
          />

          <div v-if="child.typeId == selection.numericalText" class="row mt-3">
            <div class="col-12">
              <div class="text">
                Texto Numérico:
              </div>
              <input
                class="form-control custom-bg-disabled"
                disabled
                :min="0"
                placeholder="0"
                type="number"
              />
            </div>
          </div>
          <div v-if="child.typeId == selection.openText" class="row mt-3">
            <div class="col-12">
              <div class="text">
                Texto Abierto:
              </div>
              <custom-text-area
                disabled
                :maxlength="0"
                placeholder="Escriba un comentario"
              />
            </div>
          </div>

          <horizontal-inputs
            v-if="child.typeId == selection.simpleHorizontal"
            :input.sync="child.answers"
          />
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import alertMixin from 'utils/mixins/alert.mixin';
import CustomError from 'custom-error';
import CustomTextArea from 'CustomTextArea';
import VerticalInputs from './VerticalInputs';
import HorizontalInputs from './HorizontalInputs';
import MultipleSelection from './MultipleSelection.vue';

const SELECTION = {
  MULTIPLEHORIZONTAL: 11,
  OPENTEXT: 3,
  SIMPLEVERTICAL: 5,
  SIMPLEHORIZONTAL: 6,
  MULTIPLEVERTICAL: 10,
  NUMERICALTEXT: 7,
  SIMPLEWITHCHILD: 9,
};

export default {
  name: 'SimpleWithChild',
  components: {
    CustomInput,
    CustomError,
    CustomTextArea,
    MultipleSelection,
    HorizontalInputs,
    VerticalInputs,
    CustomDropDown,
  },
  mixins: [alertMixin],
  props: {
    input: {
      type: Array,
      default: () => [],
    },
    childQuestions: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    answersTypes: {
      type: Array,
      default: () => [],
    },
    parentIndex: {
      type: Number,
      default: () => 1,
    },
  },
  data() {
    return {
      selection: {
        simpleVertical: SELECTION.SIMPLEVERTICAL,
        simpleHorizontal: SELECTION.SIMPLEHORIZONTAL,
        multipleVertical: SELECTION.MULTIPLEVERTICAL,
        multipleHorizontal: SELECTION.MULTIPLEHORIZONTAL,
        openText: SELECTION.OPENTEXT,
        numericalText: SELECTION.NUMERICALTEXT,
        simpleWithChild: SELECTION.SIMPLEWITHCHILD,
      },
      focusedChild: null,
    };
  },
  computed: {
    canAddMore() {
      return this.input.length < 5;
    },
    title() {
      return (item, index) =>
        item.name ? item.name : `Pregunta ${this.parentIndex + 1}.${index + 1}`;
    },
    availableOptions() {
      const selectedIds = this.childQuestions
        .filter((x) => x.linkedAnswer)
        .map((y) => y.linkedAnswer.id);
      return this.input.filter((x) => !selectedIds.includes(x.id));
    },
    availableAnswersTypes() {
      return this.answersTypes.filter(
        (option) => option.id !== SELECTION.SIMPLEWITHCHILD
      );
    },
  },
  async mounted() {
    this.onInputLoad();
  },

  methods: {
    onInputLoad() {
      if (this.input.length === 0) {
        this.input.push(
          { id: 1, name: '', typeId: null },
          { id: 2, name: '', typeId: null }
        );
      }
    },
    getUnselected(item) {
      if (!item.linkedAnswer) {
        this.focusedChild = null;
        return;
      }
      this.focusedChild = item.linkedAnswer;
    },

    addAnswer() {
      const newId = this.input.length + 1;
      this.input.push({ id: newId, name: '', typeId: null });
    },
    quitAnswer(index) {
      if (this.input.length > 2) {
        this.childQuestions.forEach((element) => {
          element.linkedAnswer =
            element.linkedAnswer?.id == this.input[index]?.id ||
            element.linkedAnswer?.name == this.input[index]?.name
              ? null
              : element.linkedAnswer;
        });
        this.input.splice(index, 1);
      }
    },
    addChild() {
      if (this.input.length <= this.childQuestions.length) return;

      const newId = this.childQuestions.length + 1;
      this.childQuestions.push({
        id: newId,
        name: '',
        typeId: null,
        linkedAnswer: null,
        answers: [],
      });
    },
    quitChild(index) {
      this.input = this.input.map((element) =>
        element.id === this.childQuestions[index]?.linkedAnswer?.id ||
        element.name === this.childQuestions[index]?.linkedAnswer?.name
          ? null
          : element
      );
      this.childQuestions.splice(index, 1);
    },
    async triggerConfirmation(index) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea remover la sección documentada? `,
        'Si',
        'No'
      );
      if (!answer) return;
      this.quitAnswer(index);
    },
    async triggerSubAnwserConfirmation(index) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea remover la sección documentada? `,
        'Si',
        'No'
      );
      if (!answer) return;
      this.quitChild(index);
    },
  },
};
</script>

<style scoped>
.add-button {
  color: #2cb484;
  cursor: pointer;
  font-size: 16px;
}
.custom-radio {
  transform: scale(2.1);
  margin-left: 2%;
}
.custom-border {
  border-left: solid #d9e5df;
}
.custom-sub-title {
  font-size: medium;
  font-weight: 600;
}
option.fa {
  font-weight: 400 !important;
  font-family: 'Font Awesome 5 Pro', 'Lato', sans-serif;
}
</style>
